import { ComponentProps, forwardRef, memo, Ref } from 'react';
import classNames from 'classnames';

import { ChevronIcon } from '../../icons/chevron';

import styles from './select.module.css';

type SelectProps = ComponentProps<'select'>;

export const Select = memo(
  forwardRef((props: SelectProps, ref: Ref<HTMLSelectElement>) => {
    return (
      <div className={styles.selectContainer}>
        <select {...props} ref={ref} className={classNames(styles.selectDropdown, props.className)}>
          {props.children}
        </select>
        <ChevronIcon className={styles.selectChevron} />
      </div>
    );
  })
);
